//#region Imports
import { AuthenticationService } from '@app/member-response-portal/service/authentication.service';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ConfirmHealthInsuranceDto } from '@app/member-response-portal/model/confirmHealthInsuranceDto';
import { ConfirmHealthInsuranceService } from '@app/member-response-portal/service/confirm-health-insurance.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Helper } from '@rawlings/core';
import { MemberResponseHelper } from '../../shared/member-response-helper';
import { MemberResponsePortalResponseDto } from '@app/core/models/memberResponsePortalResponseDto';
import { NavigationService } from '@app/member-response-portal/service/navigation.service';
import { NotificationRequestService } from '@app/member-response-portal/service/notification-request.service';
import { NotifierService } from '@app/core/services/notifier-service';
import { PAGES_ROUTES } from '@app/member-response-portal/model/constants';
import { SharedMemberResponseService } from '@app/member-response-portal/service/shared-member-response.service';
import { SurveyResponseDto } from '@app/member-response-portal/model/surveyResponseDto';
//#endregion Imports
@Component({
  selector: 'app-confirm-health-insurance',
  templateUrl: './confirm-health-insurance.component.html',
  styleUrls: ['./confirm-health-insurance.component.scss'],
})
export class ConfirmHealthInsuranceComponent implements OnInit {
  //#region Public Variables
    public Form: FormGroup = new FormGroup({});
    public ShowIsMedicare: boolean = false;
  //#endregion Public Variables

  //#region Protected Variables
  //#endregion Protected Variables

  //#region Private Variables
    private initialFormValue: any = null;
    private queueLetterId: number = null;
    private surveyResponseId: number = null;
  //#endregion Private Variables

  //#region Properties
    public get SurveyResponseId(): FormControl {
        return this.Form.get('SurveyResponseId') as FormControl;
    }

    public get QueueLetterId(): FormControl {
        return this.Form.get('QueueLetterId') as FormControl;
    }
    public get IsOtherInsurance(): FormControl {
        return this.Form.get('IsOtherInsurance') as FormControl;
    }
    public get IsMedicare(): FormControl {
        return this.Form.get('IsMedicare') as FormControl;
    }

    private get ConfirmHealthInsuranceDto(): ConfirmHealthInsuranceDto {
        const confirmHealthInsuranceDto: ConfirmHealthInsuranceDto = {
                SurveyResponseId: this.SurveyResponseId.value,
                QueueLetterId: this.QueueLetterId.value,
                IsOtherInsurance : MemberResponseHelper.GetBoolFromYesNoValue(this.IsOtherInsurance.value),
                IsMedicare : MemberResponseHelper.GetBoolFromYesNoValue(this.IsMedicare.value)
            };
        return confirmHealthInsuranceDto;
    }
  //#endregion Properties

  //#region Constructor and Angular Life Cycle

  //#region Constructor
    constructor(
        private authenticationService: AuthenticationService,
        private fb: FormBuilder,
        private changeDetectorRef: ChangeDetectorRef,
        private confirmHealthInsuranceService: ConfirmHealthInsuranceService,
        private navigationService: NavigationService,
        private notificationRequestService: NotificationRequestService,
        private notifierService: NotifierService,
        private sharedMemberResponseService: SharedMemberResponseService
    ) {}

    public ngOnInit(): void {
        this.queueLetterId = this.sharedMemberResponseService.GetQueueLetterId();
        this.surveyResponseId = this.sharedMemberResponseService.GetSurveyResponseId();

        if (Helper.IsEmpty(this.queueLetterId)){
            this.authenticationService.LogoutAndRedirectToLogin();
        }

        this.Form = this.fb.group({
            SurveyResponseId: [this.surveyResponseId, Validators.required],
            QueueLetterId: [this.queueLetterId, Validators.required],
            IsOtherInsurance: [null, Validators.required],
            IsMedicare: [null, Validators.required],
        });

        this.loadData();
        this.initialFormValue = this.Form.value;
    }
  //#endregion Constructor and Angular Life Cycle

  //#region Public Methods

    public HandleIsMedicareToggleEvent(event: { IsChecked: boolean; IsConfirmed: boolean }): void {
        this.IsMedicare.patchValue(MemberResponseHelper.GetStringForYesNoValue(event.IsChecked));
    }

    public HandleIsOtherInsuranceToggleEvent(event: { IsChecked: boolean; IsConfirmed: boolean }): void {
        this.ShowIsMedicare = true;
        this.IsOtherInsurance.patchValue(MemberResponseHelper.GetStringForYesNoValue(event.IsChecked));
    }

    public OnSubmit(): void {
        if(!this.Form.valid){
            this.notifierService.DisplayErrorMessage('Mandatory fields must be filled out.');
            return;
        }

        const hasFormChanged: boolean = MemberResponseHelper.HasFormChanged(this.Form, this.initialFormValue);
        if(!hasFormChanged){
            this.navigationService.NavigateTo(this.SetRouteByUserResponse());
            return;
        }

        this.confirmHealthInsuranceService
        .Save(this.ConfirmHealthInsuranceDto)
        .subscribe((result: MemberResponsePortalResponseDto) => {
            if (result.Success) {
                this.sharedMemberResponseService.SetSurveyResponse(this.buildSurveyResponse());
                this.navigationService.NavigateTo(this.SetRouteByUserResponse());
            } else {
                this.notificationRequestService.ShowFailedRequestAndLogout(null);
            }
        });
    }

  //#endregion Public Methods

  //#region Private Methods

    private buildSurveyResponse(): SurveyResponseDto{
        const surveyResponseDto: SurveyResponseDto = this.sharedMemberResponseService.GetSurveyResponse();

        surveyResponseDto.IsOtherInsurance = this.IsOtherInsurance.value;
        surveyResponseDto.IsMedicare = this.IsMedicare.value;
        return surveyResponseDto;
    }

    private loadData() : void {
        const surveyResponseData: SurveyResponseDto = this.sharedMemberResponseService.GetSurveyResponse();

        if (surveyResponseData) {
            this.Form.patchValue({
                IsOtherInsurance: MemberResponseHelper.GetStringToggleValue(surveyResponseData.IsOtherInsurance),
                IsMedicare: MemberResponseHelper.GetStringToggleValue(surveyResponseData.IsMedicare),
            });

            this.ShowIsMedicare = this.IsOtherInsurance.valid;
            this.Form.updateValueAndValidity();
            this.changeDetectorRef.detectChanges();
        }
    }

    private SetRouteByUserResponse() : string {
        let routeToNavigate : string = PAGES_ROUTES.SURVEY;
        if(!this.ConfirmHealthInsuranceDto.IsMedicare &&
           !this.ConfirmHealthInsuranceDto.IsOtherInsurance) {
            routeToNavigate = PAGES_ROUTES.CONFIRMATION;
        }
        return routeToNavigate;
    }
  //#region Private Methods
}
